import { render } from "./BenchmarkAdd.vue?vue&type=template&id=52a7a679&ts=true"
import script from "./BenchmarkAdd.vue?vue&type=script&lang=ts"
export * from "./BenchmarkAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__